export const Types = {
  PASSWORD_RESET: 'PASSWORD_RESET',
  PASSWORD_RESET_FAIL: 'PASSWORD_RESET_FAIL',
  PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
  CLEAR_UI_STATE: 'RESET_PASSWORD/CLEAR_UI_STATE',
};

export const onPasswordReset = (
  recoveryToken,
  password,
  cognitoChallenge,
  cognitoForgotPassword,
) => ({
  type: Types.PASSWORD_RESET,
  payload: {
    recoveryToken,
    password,
    cognitoChallenge,
    cognitoForgotPassword,
  },
});

export const onPasswordResetSuccess = () => ({
  type: Types.PASSWORD_RESET_SUCCESS,
});

export const onPasswordResetFail = (error) => ({
  type: Types.PASSWORD_RESET_FAIL,
  payload: { error },
});

export const clearUiState = () => ({
  type: Types.CLEAR_UI_STATE,
});
